import { render, staticRenderFns } from "./company_order.vue?vue&type=template&id=b0b064de&scoped=true"
import script from "./company_order.vue?vue&type=script&lang=js"
export * from "./company_order.vue?vue&type=script&lang=js"
import style0 from "./company_order.vue?vue&type=style&index=0&id=b0b064de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b064de",
  null
  
)

export default component.exports